import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { useSelector, useDispatch } from 'react-redux';
import CustomButton from 'app/main/components/button/Button';
import { RxCircle } from "react-icons/rx";
import * as Actions from 'app/store/actions';

function Menu() {
    const ctm = useSelector(({ ctm }) => ctm);
    const project = useSelector(({ members }) => members);
    const dispatch = useDispatch();
    const projectCode = project.members.handleMembers_projectSelected?.projectCode;
    const currentProjectName = project.members.handleMembers_projectSelected?.project_type?.name;

    const openInNewTab = url => {
        window.open(url, '_blank', "toolbar=yes,scrollbars=yes,resizable=yes,top=50,left=50,width=1920,height=1080");
    }

    // useEffect(() => {
    //   console.log('DEBUG! ProjectCode for dispatch: ', projectCode);
    //   console.log('DEBUG! ProjectCode for dispatch: ', currentProjectName);
    //   console.log('DEBUG! ProjectCode for dispatch: ', ctm.landing.projectExtraURLs);
    //   let tmpId = 12;
    //   const projectExtraUrls = ctm.landing.projectExtraURLs;
    //   for( let i = 0; i < projectExtraUrls.length; i++) {
    //     console.log("DEBUG projectExtraUrls", projectExtraUrls[i]['label']);
    //     menuItems.push(
    //         {
    //             id: (tmpId+i), name: projectExtraUrls[i]['label'], icon: null, onClick: () => openInNewTab(projectExtraUrls[i]['url']),
    //         }
    //     )
    //     console.log("DEBUG menuItems : ", menuItems);
    //   }
      
    // }, [ctm.landing.projectExtraURLs]);

    // function generateCctvURL() {
    //     const url = ctm.landing.faceCamera.cctv_url;
    //     return url;
    // }
    function generateViewerURL(constCd, td) {
        const token = ctm.landing.tfasToken.token;
        const url = `${process.env.REACT_APP_AWS_VIEWER_URL_TFAS}/?token=${token}&const_cd=${constCd}&td=${constCd + '_' + td}`;
        return url;
    }

    function formatNumber(number, integerDigits = 5, decimalPlaces = 3) {
        if (number === undefined) {
            return '';
        }
        const formattedNumber = parseFloat(number).toFixed(decimalPlaces);
        const [integerPart, decimalPart] = formattedNumber.split('.');

        const paddedInteger = integerPart.padStart(integerDigits, '0');
        const paddedDecimal = decimalPart.padEnd(decimalPlaces, '0');

        return `${paddedInteger}.${paddedDecimal}`;
    };

    let menuItems = []
    let index = 1;

    if(ctm.landing.tfasToken !== null && ctm.landing.tfasToken !== undefined && ctm.landing.measurementPoint[3] && ctm.landing.measurementPoint[3].data.length !== 0) {
        menuItems.push(
            {
                id: index, name: 'tunnel_face_assessment_system', icon: null, onClick: () => openInNewTab(generateViewerURL(project.members.handleMembers_projectSelected?.projectCode, formatNumber(ctm.aMeasurement.nearestPoint.nearestTFS))),
                //disabled: ctm.landing.tfasToken !== null && ctm.landing.tfasToken !== undefined && ctm.landing.measurementPoint[3] && ctm.landing.measurementPoint[3].data.length !== 0 ? false : true,
                //iconClassName: ctm.landing.tfasToken !== null && ctm.landing.tfasToken !== undefined && ctm.landing.measurementPoint[3] && ctm.landing.measurementPoint[3].data.length !== 0 ? 'tfs' : 'tfsHidden',
                //className: ctm.landing.tfasToken !== null && ctm.landing.tfasToken !== undefined && ctm.landing.measurementPoint[3] && ctm.landing.measurementPoint[3].data.length !== 0 ? 'ctmMenu' : 'ctmMenuHidden',
                iconClassName: 'tfs',
                className: 'ctmMenu',
            },
        )
        index += 1;
    }
    if(ctm.landing.measurementPoint[2] && ctm.landing.measurementPoint[2].data.length !== 0) {
        menuItems.push(
            {
                id: index, name: 'tunnel_remote_view', icon: null, onClick: () => openInNewTab('https://remote-view.ad-hzm.co.jp/remoteview/' + project.members.handleMembers_projectSelected?.projectCode + '?td=' + ctm.aMeasurement.nearestPoint.given_tunnel_dist),
                //disabled: ctm.landing.measurementPoint[2] && ctm.landing.measurementPoint[2].data.length !== 0 ? false : true,
                //iconClassName: ctm.landing.measurementPoint[2] && ctm.landing.measurementPoint[2].data.length !== 0 ? 'trv' : 'trvHidden',
                //className: ctm.landing.measurementPoint[2] && ctm.landing.measurementPoint[2].data.length !== 0 ? 'ctmMenu' : 'ctmMenuHidden',
                iconClassName: 'trv',
                className: 'ctmMenu',
            },
        )
        index += 1;
    }
    if(ctm.landing.faceCamera[0] && ctm.landing.faceCamera[0].data.length !== 0) {
        menuItems.push(
            {
                id: index, name: 'face_camera' , icon: null,
                onClick: () => openInNewTab(ctm.landing.faceCamera[0].data),
                //disabled:  ctm.landing.faceCamera[0] && ctm.landing.faceCamera[0].data.length !== 0 ? false : true,
                //className: ctm.landing.faceCamera[0] && ctm.landing.faceCamera[0].data.length !== 0 ? 'ctmMenu' : 'ctmMenuHidden'
                className: 'ctmMenu'
            },
        )
        index += 1;
    }
    if(ctm.landing.measurementPoint[0] && ctm.landing.measurementPoint[0].data.length !== 0) {
        menuItems.push(
            {
                id: index, name: 'a_measurement', icon: <RxCircle />,
                onClick: () => openInNewTab(`${process.env.REACT_APP_SERVER_FRONT}/ctm/a-measurement/td/${ctm.aMeasurement.nearestPoint.nearestAMeasurement}/stationPt/${ctm.aMeasurement.nearestPoint.station_point}/supportPt/${ctm.aMeasurement.nearestPoint.support_ptn}`),
                //disabled: ctm.landing.measurementPoint[0] && ctm.landing.measurementPoint[0].data.length !== 0 ? false : true,
                //iconClassName: ctm.landing.measurementPoint[0] && ctm.landing.measurementPoint[0].data.length !== 0 ? 'aMeasurement' : 'aMeasurementHidden',
                //className: ctm.landing.measurementPoint[0] && ctm.landing.measurementPoint[0].data.length !== 0 ? 'ctmMenu' : 'ctmMenuHidden',
                iconClassName: 'aMeasurement',
                className: 'ctmMenu',
            },
        )
        index += 1;
    }
    if(ctm.landing.bMeasurement) {
        menuItems.push(
            {
                id: index, name: 'b_measurement',
                //disabled: ctm.landing.bMeasurement ? false : true,
                //className: ctm.landing.bMeasurement ? 'ctmMenu' : 'ctmMenuHidden'
                className: 'ctmMenu'
            },
        )
        index += 1;
    }
    if(ctm.landing.measurementPoint[1] && ctm.landing.measurementPoint[1].data.length !== 0) {
        menuItems.push(
            {
                id: index, name: 'tft', icon: <RxCircle />, onClick: () => openInNewTab(`${process.env.REACT_APP_SERVER_FRONT}/ctm/tft/pdf`),
                //disabled: ctm.landing.measurementPoint[1] && ctm.landing.measurementPoint[1].data.length !== 0 ? false : true,
                //iconClassName: ctm.landing.measurementPoint[1] && ctm.landing.measurementPoint[1].data.length !== 0 ? 'tft' : 'tftHidden',
                //className: ctm.landing.measurementPoint[1] && ctm.landing.measurementPoint[1].data.length !== 0 ? 'ctmMenu' : 'ctmMenuHidden',
                iconClassName: 'tft',
                className: 'ctmMenu',
            },
        )
        index += 1;
    }
    if(ctm.landing.tunnelStationPoint && ctm.landing.tunnelStationPoint.data && ctm.landing.tunnelStationPoint.data.length > 0) {
        menuItems.push(
            {
                id: index, name: 'process_simulator',
                onClick: () => openInNewTab(`http://sv00039w/procgi14/procgi.exe?P=LoginTNLSR&WriteReport=Login`),
                //#disabled: ctm.landing.tunnelStationPoint && ctm.landing.tunnelStationPoint.data && ctm.landing.tunnelStationPoint.data.length > 0 ? false : true,
                //className: ctm.landing.tunnelStationPoint && ctm.landing.tunnelStationPoint.data && ctm.landing.tunnelStationPoint.data.length > 0 ? 'ctmMenu' : 'ctmMenuHidden'
                className: 'ctmMenu',
            },
        )
        index += 1;
    }

    const projectExtraUrls = ctm.landing.projectExtraURLs;
    if (projectExtraUrls !== undefined && projectExtraUrls.length > 0) {
        for (let i = 0; i < projectExtraUrls.length; i++) {
            const label = projectExtraUrls[i]['label'];
            const url = projectExtraUrls[i]['urls'];
            if (!label || !url) {
                continue;
            }
            menuItems.push(
                {
                    id: index, name: label, icon: null, onClick: () => openInNewTab(url),
                    className: 'ctmMenu',
                }
            );
            index += 1;
        }
    }

        // {
        //     id: 1, name: 'face_photo',
        //     disabled: ctm.landing.facePhoto ? false : true,
        //     className: ctm.landing.facePhoto ? 'ctmMenu' : 'ctmMenuHidden'
        // },
        // {
        //     id: 2, name: 'scanner',
        //     disabled: ctm.landing.scanner ? false : true,
        //     className: ctm.landing.scanner ? 'ctmMenu' : 'ctmMenuHidden'
        // },
        // {
        //     id: 3, name: 'assessment',
        //     disabled: ctm.landing.assessment ? false : true,
        //     className: ctm.landing.assessment ? 'ctmMenu' : 'ctmMenuHidden'
        // },
        // {
        //     id: 10, name: 'step_mgmt',
        //     disabled: ctm.landing.stepManagement ? false : true,
        //     className: ctm.landing.stepManagement ? 'ctmMenu' : 'ctmMenuHidden'
        // },

    return (
        <Grid container spacing={1}>

            {menuItems.map(item => (
                <CustomButton
                    key={item.id}
                    className={item.className}
                    name={item.name}
                    i18n={"ctm"}
                    onClick={item.onClick}
                    isDisabled={item.disabled}
                    icon={item.icon}
                    iconClassName={item.iconClassName}
                />
            ))}

        </Grid>
    )
}

export default Menu